// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionEvaluationResultInputFormal } from './submissionEvaluationResultInputFormal';
import type { SubmissionEvaluationResultInputDescription } from './submissionEvaluationResultInputDescription';
import type { SubmissionEvaluationResultInputAnalysis } from './submissionEvaluationResultInputAnalysis';
import type { SubmissionEvaluationResultInputApplication } from './submissionEvaluationResultInputApplication';
import type { SubmissionEvaluationResultInputReflection } from './submissionEvaluationResultInputReflection';

/**
 * Evaluation result of a submission
 */
export interface SubmissionEvaluationResultInput {
  /** Evaluation of FORMAL dimension */
  formal?: SubmissionEvaluationResultInputFormal;
  /** Evaluation of DESCRIPTION dimension */
  description?: SubmissionEvaluationResultInputDescription;
  /** Evaluation of ANALYSIS dimension */
  analysis?: SubmissionEvaluationResultInputAnalysis;
  /** Evaluation of APPLICATION dimension */
  application?: SubmissionEvaluationResultInputApplication;
  /** Evaluation of REFLECTION dimension */
  reflection?: SubmissionEvaluationResultInputReflection;
}
